module.exports = __webpack_public_path__ + "img/s2.d19f701b.png";